import {BaseContainerModel} from '../base-container.model';
import {bl_inv_serial_number_event_RowClass} from '../../dbschema/bl_inv_serial_number_event.model';
import {bl_inv_serial_number_ext_RowClass} from '../../dbschema/bl_inv_serial_number_ext.model';
import {bl_inv_serial_number_hdr_RowClass} from '../../dbschema/bl_inv_serial_number_hdr.model';
import {bl_inv_serial_number_line_RowClass} from '../../dbschema/bl_inv_serial_number_line.model';

export class SerialNumberContainerModel extends BaseContainerModel {
  bl_inv_serial_number_hdr: bl_inv_serial_number_hdr_RowClass = new bl_inv_serial_number_hdr_RowClass();
  bl_inv_serial_number_lineList: bl_inv_serial_number_line_RowClass[] = [];
  bl_inv_serial_number_extList: bl_inv_serial_number_ext_RowClass[] = [];
  bl_inv_serial_number_eventList: bl_inv_serial_number_event_RowClass[] = [];
}
